import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Fare List Container
 */

/**
 * This method return a Request object after delete unnecesary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformSmartBusRequest = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [];
  // params to delete when has empty value
  const paramsEmpty = ['groupLevel', 'lockFirstResult'];
  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);
  return cleanRequest;
};

export default transformSmartBusRequest;
